




















































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import { ICheckout } from '@/interfaces/Checkout';
import { EPaymentMethod } from '@/helpers/enums';
import { Payment } from '@/classes/Checkout/Payment';

const CheckoutModule = namespace('App/Checkout');
const CustomerModule = namespace('App/Customer');

@Component
export default class PlanMobile extends Vue {
  @Prop() private invoice: any;

  @CheckoutModule.State(state => state.checkout)
  private checkout: ICheckout;

  @CustomerModule.Getter('isLogged')
  private customerIsLogged: boolean;

  @CheckoutModule.Getter('selectedOfferPayment')
  private payment!: Payment;

  get paymentMethods() {
    return EPaymentMethod;
  }

  get installmentsNumber(): number {
    return (
      this.invoice &&
      this.invoice.paymentMethodInstallments &&
      this.invoice.paymentMethodInstallments.number
    );
  }

  get installmentsPrice(): number {
    return (
      this.invoice &&
      this.invoice.paymentMethodInstallments &&
      this.invoice.paymentMethodInstallments.amount
    );
  }

  private get subtitle(): string | null | undefined {
    return this.checkout.cart.offer && this.checkout.cart.offer.subtitle;
  }

  private get intervalType(): string | null | undefined {
    return this.checkout.cart.offer && this.checkout.cart.offer.interval_type;
  }

  get intervalTypeName(): string {
    if (!this.intervalType) return '';
    const tPlan = this.$t('App.Checkout.plan');
    const tIntervalType = this.$t(
      `App.Checkout.intervalType.${this.intervalType}`
    );
    return `${tPlan} ${tIntervalType}`;
  }

  scrollToBottom() {
    const { setTimeout, scrollBy } = window;
    const { body, documentElement: html } = document;
    const height = Math.max(
      body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight
    );
    const amt = height / 100;
    const time = Math.max(height * 0.2, 600);
    let curTime = 0;
    while (curTime <= time) {
      setTimeout(() => scrollBy(0, amt), curTime);
      curTime += time / 100;
    }
  }
}
